import { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { authServices } from "../../APIServices/UserData/authServices";

const SetupPrimaryProperty = ({
  setNextStep,
  setName,
  name,
  setEmail,
  email,
  setLoader,
  loader
}) => {
  const [propertyName, setPropertyName] = useState("");
  const [ddomain, setDdomain] = useState("");

  const setUpProperty = async () => {
    setLoader(true)
    let userData = {}
    userData.propertyName = propertyName
    userData.ddomain = ddomain
    userData.email = email
    userData.name = name
    let data = await authServices.setUpProperty(userData)
    if (data?.statusCode === 200) {
      setNextStep(data?.status)
      setName(data?.name)
      setEmail(data?.email)
      setPropertyName("")
      setDdomain("")
    }
    setLoader(false)
  }
  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>Website / App Name</Form.Label>
        <Form.Control
          onChange={(e) => setPropertyName(e.target.value)}
          value={propertyName}
          className="form-input"
          placeholder="Enter Website / App name"
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Domain</Form.Label>
        <Form.Control
          onChange={(e) => setDdomain(e.target.value)}
          value={ddomain}
          as="textarea"
          className="form-input"
          placeholder="Enter Domain name (URL)"
        />
      </Form.Group>
      <div className="hstack gap-2">
        <Button
          disabled={loader || !propertyName}
          className="w-100 btn-primary"
          onClick={setUpProperty}>
          Save & Continue
        </Button>
      </div>
    </>
  );
};

export default SetupPrimaryProperty;
